/* eslint-disable indent */
/* eslint-disable no-unused-vars */

const isObj = require('lodash.get');

export const getShieldsByDeviceId = (state) => isObj(state, 'shieldsByDeviceId', []);
export const getDevicesByShieldId = (state) => isObj(state, 'devicesByShieldId', []);
export const getDevicesByUserId = (state) => isObj(state, 'devicesByUserId', []);
export const getShieldsByUserId = (state) => isObj(state, 'shieldsByUserId', []);
